import styled from 'styled-components';

export const HoverSortingContainer = styled.div`
  align-self: center;
  font-size: 1rem;
  height: 30px;
  display: flex;
  color: ${({ theme }) => theme.baseBlue.a6};
  align-items: center;
  width: auto;
  max-width: fit-content;
  float: right;
`;

export const HoverSortingContentBox = styled.div`
  min-height: 60px;
  overflow-y: auto;
  font-weight: 200;
  border-radius: 4px;
  position: relative;
  z-index: 9;
`;

HoverSortingContentBox.displayName = 'HoverSortingContentBox';

export const SortContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 10rem;
`;

export const SortingItem = styled.div<{ $selected: boolean }>`
  padding: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
  background-color: ${({ $selected, theme }) => ($selected ? theme.black.a0 : theme.white.a10)};
  font-size: 15px;
  line-height: 26px;
  cursor: pointer;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a6};
  white-space: nowrap;

  &:hover {
    background-color: ${({ theme }) => theme.baseBlue.a10};
    color: ${({ theme }) => theme.white.a10};
  }

  &:nth-last-child(1) {
    border: none;
  }
`;
